import _get from 'lodash/get';
import { multipleComponentIterator } from '../MultipleComponentIterator/MultipleComponentIterator.utils';
export function multipleComponentIteratorMap(_ref) {
  var lookupField = _ref.lookupField,
    targetValues = _ref.targetValues,
    iterator = _ref.iterator,
    components = _ref.components,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? null : _ref$limit;
  var finalIterator = iterator.filter(function (item) {
    var currentId = _get(item, lookupField);
    return targetValues.includes(currentId);
  });
  return multipleComponentIterator({
    iterator: finalIterator,
    components: components,
    limit: limit
  });
}